export const CONTACT_EMAIL = "seedless1017@gmail.com";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const YT_CHANNEL_URL = "https://youtube.com/@kashaethegod?si=w_RmFIAoZYWGggu1";
export const YT_UPLOADS_PLAYLIST = "UUj8W5XQrRSuycwfeG1vgXKw";

export const DEFAULT_VIDEOS = [
  { id: "paper-crown", type: "video", title: "Paper Crown", artist: "Kashae The God", url: "https://www.youtube.com/watch?v=0HKV8b4CxPs" },
];

export const PLATFORMS = [
  { key: "youtube", name: "YouTube", color: "#FF0033", url: YT_CHANNEL_URL, cta: "Subscribe" },
  { key: "spotify", name: "Spotify", color: "#1ED760", url: "", cta: "Follow" },
  { key: "apple", name: "Apple Music", color: "#FA2D48", url: "", cta: "Listen" },
  { key: "pandora", name: "Pandora", color: "#3668FF", url: "", cta: "Play" },
  { key: "soundcloud", name: "SoundCloud", color: "#FF5500", url: "", cta: "Listen" },
  { key: "tidal", name: "Tidal", color: "#F2EEE3", url: "", cta: "Stream" },
];

export const SOCIALS = [
  { key: "instagram", name: "Instagram" },
  { key: "tiktok", name: "TikTok" },
];

export const mergePlatforms = (links = {}) =>
  PLATFORMS.map((p) => ({ ...p, url: (links?.[p.key] ?? "").trim() || (p.key === "youtube" ? p.url : "") }));

export const ytId = (url = "") => {
  const m = url.match(/(?:youtu\.be\/|v=|\/embed\/|\/shorts\/|\/live\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
};

export const mediaUrl = (u = "") => (u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const videoThumb = (v) => {
  if (v?.cover) return mediaUrl(v.cover);
  const id = ytId(v?.url);
  if (id === "0HKV8b4CxPs") return "/paper-crown.jpg";
  return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : "/studio.jpg";
};

export const toEmbed = (key, url) => {
  if (!url) return null;
  if (key === "spotify" && url.includes("open.spotify.com")) return url.replace("open.spotify.com/", "open.spotify.com/embed/").split("?")[0];
  if (key === "apple" && url.includes("music.apple.com")) return url.replace("music.apple.com", "embed.music.apple.com");
  return null;
};
